export enum ParentTypeEnumerator {
  DASHBOARD = 1,
  ODS_CONTENT = 2,
  COMPETENCE = 3,
}